import script from "./CoreUiChatMessageInfoDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatMessageInfoDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatMessageInfoDialog.vue?vue&type=style&index=0&id=14a751aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14a751aa"]])

export default __exports__